import React, { useEffect, useState } from 'react';
import './App.css';
import Navbar from './Components/Navbar';
import { HelmetProvider } from "react-helmet-async";
import MainRoutes from './Pages/MainRoutes';
import Footer from './Components/Footer';

function App() {
  const helmetContext = {};

  const [showFooter, setShowFooter] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFooter(true);
    }, 2000); // 2 seconds
    return () => clearTimeout(timer); // cleanup on unmount
  }, []);

  return (
    <div>
      <HelmetProvider context={helmetContext}>
        <Navbar />
        <MainRoutes />
        {showFooter && <Footer />}
      </HelmetProvider>
    </div>
  );
}

export default App;
